<template>
  <div :style="styleObject">
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-confirm-pin-code"
      data-bs-toggle="modal"
      data-bs-target="#modalConfirmPinCode"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-confirm-pin-code"
      data-bs-dismiss="modal"
      data-bs-target="#modalConfirmPinCode"
    ></button>
    <div
      class="modal fade"
      id="modalConfirmPinCode"
      tabindex="-1"
      aria-labelledby="modalConfirmPinCodeLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-end pt-2 pb-2">
            <div class="btn-close-modal" data-bs-dismiss="modal">
              <div>&times;</div>
            </div>
          </div>
          <div class="modal-body">
            <div class="input-container text-center">
              <div style="font-size: 24px; color: red; font-weight: bold;">{{ $t("kiosk.pin.attention") }}</div>
              <div style="font-size: 18px;">{{ $t("kiosk.pin.staffRequired") }}</div>
              <input 
                type="password" 
                class="form-control search-input mt-3"
                :placeholder="$t('kiosk.pin.pending')"
                v-model="pinCode"
                style="
                  border-radius: 5px;
                  padding: 10px;
                  padding-right: 40px;
                  border: 1px solid #ddd;
                  width: 100%;
                  font-size: 14px;
                  direction: ltr !important;
                  text-align: left !important;
                "
                @keyup.enter="confirmPinCode"
              >
            </div>
            <div class="text-danger mt-1" v-if="!status">
                {{ $t("kiosk.pin.incorrect") }}
              </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              type="button"
              class="btn-close-modal-footer"
              data-bs-dismiss="modal"
            >
              {{ $t("kiosk.common.cancel") }}
            </button>

          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KioskService from "../../../services/kiosk.service";
import MaterialLoading from "@/components/MaterialLoading.vue";

export default {
  name: "ModalConfirmPinCode",
  components: {
    MaterialLoading,
  },
  props: {
    keyReload: {
      required: true,
    },
  },
  data() {
    return {
      merchantCode: "",
      branchCode: "",
      pinCode: "",
      searchTimerId: null,
      status: true,
      loaderActive: false,
    };
  },
  mounted() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.color,
      };
    },
  },
  methods: {
    // onChangePincode(event) {
    //   this.pinCode = event.target.value;
    //   this.status = true;
    //   clearTimeout(this.searchTimerId);
    //   this.searchTimerId = setTimeout(() => {
    //     this.confirmPinCode();
    //   }, 500);
    // },
    confirmPinCode() {
      this.showLoader();
      this.status = true;
      let dataForm = {
        branch_code: this.branchCode,
        pin_code: this.pinCode
      };

      KioskService.confirmPinCode(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.status = response.data.data.status;

            if (this.status) {
              this.$emit('confirm-pin-code');
            }
          }
          this.hideLoader();
        },
        (error) => {
          console.log(error.response.data.result.message);
          this.hideLoader();
        }
      );
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
  },
  watch: {
    keyReload() {
      this.pinCode = "";
      this.status = true;
    },
  },
};
</script>

<style scoped>
.modal {
  overflow-y: hidden !important;
}

.modal-dialog {
  top: 50%;
  transform: translate(0, -50%) !important;
}

.modal-content {
  max-width: 300px;
}

.btn-close-modal {
  font-size: 24px !important;
  font-weight: bold;
  cursor: pointer;
}

.btn-close-modal-footer {
  border: 1px solid var(--color);
  background-color: var(--color);
  border-radius: 5px;
  color: #ffffff;
  padding: 5px 30px;
}

.search-input::placeholder {
  text-align: left !important;
  direction: ltr !important;
}
</style>
